<script>
  import * as t3dApp from "../model/model";
  import MarkInfoDRAIN from "./markInfo_DRAIN.svelte";
  import TopBtn from "./topBtn.svelte";
  import products from "../../public/data/data";
  import GetQueryString from "../utils/getQuerySting";
  import ScanBtn from "./scanBtn.svelte";

  console.log(products);
  let product_link;
  let product_pdfs = [];
  let product_titles = [];

  let coregv;

  //  设置后面用于记录当滚动想前滚动时，相机看的点位
  let wheelUpCameraPoint;
  let wheelUpCamera;

  // console.log(product_title);

  // 获取html链接中是否带有某个参数，如果带有的话，获取参数，从而判断使用哪个模型
  console.log("querystrin外部", GetQueryString("coregv"));

  if (
    GetQueryString("coregv") != null &&
    GetQueryString("coregv") != null &&
    GetQueryString("coregv") <= 4 &&
    GetQueryString("coregv") > 0
  ) {
    // 对token重新赋值
    coregv = GetQueryString("coregv");
    console.log("querysting内部", coregv);
  } else {
    coregv = 1;
  }

  t3dApp
    .createApp(
      "t3d_container",
      `model/model-${coregv}/model.gltf.xz`,
      "./visual_logic.js"
    )
    .then((val) => {
      console.log(val);
    });
  let count_value;
  let markNums = new Array();
  let emptyNums;
  let mps = new Array();
  document.addEventListener("loadingModelFinished", (e) => {
    console.log("播放事件成功", e);
    setTimeout(() => {
      emptyNums = t3dApp.recordEmpnyNum();
      emptyNums.forEach((element, index) => {
        mps.push(element);
        mps = mps;
      });
    }, 200);
  });

  /**
   * markNum1用于判断标注卡片DRAIN的状态（是否被选中）
   */
  let markStatus = 0;

  // 定义标注点选中状态
  let markPoint = 0;

  // 监听topBtn组件中的mark点击事件
  function handleMessage(event) {
    markPoint = event.detail.text;
    if (markPoint == 0) {
      markStatus = event.detail.text;
    } else {
    }
  }

  function listenSizeMessage(event) {
    markPoint = event.detail.message;
    markStatus = event.detail.message;
  }

  // 定义标注点点击事件
  function markPointclick(event) {
    t3dApp.tweenCameraFuc(
      `pointCamera${event.target.id}`,
      `pointTarget${event.target.id}`,
      "1"
    );
    // markNums[event.target.id-1] =1
    markStatus = 1;
    t3dApp.eventControl("enableZoom", false);

    wheelUpCamera = `pointCamera${event.target.id}`;
    wheelUpCameraPoint = `pointTarget${event.target.id}`;
  }

  function alterBlock(event) {
    product_titles = products[coregv - 1][event.target.id - 1].title;
    product_link = products[coregv - 1][event.target.id - 1].link;
    product_pdfs = products[coregv - 1][event.target.id - 1].pdf;

    t3dApp.bindPoint("DRAIN", `pointTarget${event.target.id}`);
    t3dApp.setLeftStyle("30px", "DRAIN");
    t3dApp.setTopStyle("30px", "DRAIN");
  }

  function markNumListener(event) {
    markStatus = 0;
    markPoint = 1;
    t3dApp.tweenCameraFuc("startCamera", "startTarget", "0.6");
    console.log("aaa");
    t3dApp.eventControl("enableZoom", true);
  }

  // 设置鼠标滚轮事件--当鼠标向下滚时触发

  let last_known_scroll_position = 0;
  let first_known_scroll_position = 0;
  let ticking = false;

  function doSomething(scroll_pos) {
    // 根据滚动位置做的事
  }

  document.addEventListener("wheelDown", function (e) {
    if (markStatus == 1) {
      t3dApp.eventControl("enableZoom", false);
      t3dApp.tweenCameraFuc("startCamera", "startTarget", "0.6");
    }
  });

  document.addEventListener("wheelUp", function (e) {
    if (markStatus == 1) {
      t3dApp.eventControl("enableZoom", false);
      t3dApp.tweenCameraFuc(wheelUpCamera, wheelUpCameraPoint, "0.6");
    }
  });
</script>

<main>
  <div id="t3d_container">
    <TopBtn
      {mps}
      {markPoint}
      {markStatus}
      on:message={handleMessage}
      on:sendMessage={listenSizeMessage}
    />
    <div style="display: {markStatus == 1 ? 'block' : 'none'}">
      <MarkInfoDRAIN on:message={markNumListener}>
        {#each product_titles as product_title}
          <p>{product_title}</p>
        {/each}

        <div class="content">
          <div class="link">
            <img src="./img/link.svg" alt="" /><span
              ><a href={product_link} target="_blank">Link zum Produkt</a></span
            >
          </div>
          {#each product_pdfs as pdf, index}
            <div class="laodingPDF">
              <img src="./img/load.svg" alt="" /><span
                ><a href={pdf.link} target="_blank">{pdf.name}</a></span
              >
            </div>
          {/each}
        </div>
      </MarkInfoDRAIN>
    </div>

    <!-- 定义标注点 -->
    {#each mps as mp}
      <span
        class={markPoint == 1 ? "markPoint select" : "markPoint disselect"}
        id={mp}
        on:click={markPointclick}
        on:click={alterBlock}
      />
    {/each}
    <ScanBtn coregvId={coregv} />
  </div>
</main>

<style>
  p {
    font-size: 24.96px;
    margin: 8px 22px 8px 22px;
    font-family: "latoBlack", sans-serif;
    font-weight: bold;
    width: auto;
    line-height: 28px;
    word-break: break-word;
    overflow-wrap: break-word;
    letter-spacing: 0.5px;
    user-select: none;
  }
  #t3d_container {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }

  .markPoint {
    width: 15px;
    height: 15px;
    display: inline-block;
    margin: -10.5px 0 0 -10.5px;
    border: 3px solid white;
    border-radius: 50%;
    background-color: #0089ca;
    user-select: none;
    position: absolute;
    cursor: pointer;
    font-family: "Lato", sans-serif;
  }
  .disselect {
    display: none;
  }
  .select {
    display: block;
  }
  .content {
    overflow: hidden;
    margin: 11px 22px 11px 22px;
    font-size: 16px;
  }

  .laodingPDF {
    margin: 9px 0 4px 0;
  }
  .link {
    font-family: "latoRegular", sans-serif;
    padding: 5px 0px 6px 0px;
  }
  img {
    vertical-align: middle;
    margin-right: 5px;
    width: 15px;
  }
  span {
    vertical-align: middle;
  }
  a {
    color: white;
  }
  a:link {
    text-decoration: none;
  }
  a:active {
    text-decoration: none;
  }
</style>
